import { useEffect, useState } from "react"
import Modal from "../../../components/Modal"
import InputText from "../../../components/InputText"
import TeamMemberInterface from "../../../interfaces/TeamMember.interface"
import { useDebounce } from "use-debounce"
import { useAppSelector } from "../../../store/store"
import { createTeamContract, searchTeamMember } from "../../../services/team.services"
import { toast } from "react-toastify"
import { X } from "lucide-react"
import TextArea from "../../../components/TextArea"
import Button from "../../../components/Button"

const SearchMember: React.FC<{ onSelect?: (member: TeamMemberInterface) => void }> = ({ onSelect = () => { } }) => {
    const [name, setName] = useState<string>("")
    const [results, setResults] = useState<TeamMemberInterface[]>([])
    const [memberSelected, setMemberSelected] = useState<TeamMemberInterface | null>(null)

    const token = useAppSelector(state => state.token)
    const team = useAppSelector(state => state.team)

    const [searchValue] = useDebounce(name, 500)


    const selecMember = (member: TeamMemberInterface) => {
        setMemberSelected(member)
        onSelect(member)
    }


    useEffect(() => {
        if (searchValue.length === 0) return
        searchTeamMember({ token: token || "", name: searchValue, teamId: team.id as string })
            .then((res) => {
                setResults(res.data.payload.search)
            })
            .catch((err) => {
                toast.error(err.response.data.message)
            })
    }, [searchValue])

    return (
        <div className="flex flex-col gap-2">
            <p className="uppercase text-zinc-700 text-sm">Buscar jugador</p>
            <InputText type="search" placeholder="Nombre" onChange={(event) => setName(event.target.value)} value={name} />

            {
                results.map((teamMember) => (
                    <button key={teamMember.id} onClick={() => selecMember(teamMember)}>{teamMember.player?.name}</button>
                ))
            }

        </div>
    )
}

const NewContractForm = () => {
    const token = useAppSelector(state => state.token)
    const team = useAppSelector(state => state.team)

    const [requesting, setRequesting] = useState(false)
    const [showForm, setShowFrom] = useState(false)
    const [member, setMember] = useState<TeamMemberInterface | null>(null)
    const initForm = {
        value: 0.00,
        startDate: "",
        endDate: "",
        conditions: ""
    }
    const [form, setForm] = useState(initForm)

    const handleInputChange: React.ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement> = (event) => {
        setForm({ ...form, [event.target.name]: event.target.value })
    }

    const handleSubmit = () => {
        setRequesting(true)

        createTeamContract({
            ...form,
            teamMemberId: member?.id as string,
            teamId: team?.id as string,
            token: token || ""
        })
            .then(() => {
                toast.success("¡Contratro creado!")
                setShowFrom(false)
                setForm(initForm)
                setMember(null)
            })
            .catch((error) => {
                toast.error(error.response.data.message)
            })
            .finally(() => setRequesting(false))
    }

    return (
        <>
            <button className="text-blue-500 uppercase" onClick={() => setShowFrom(true)}>Nuevo contrato</button>

            <Modal modalOpen={showForm} set={setShowFrom}>
                <div className="w-[420px] flex flex-col gap-5 bg-white p-5 rounded">
                    <p className="text-zinc-700 text-xl">Nuevo Contrato</p>
                    {
                        member ?
                            <div className="flex flex-col gap-2">
                                <p className="text-zinc-700 uppercase text-sm">Jugador</p>
                                <div className="flex justify-between items-center border rounded border-gray-100 p-2">
                                    <p className="text-zinc-700 text-lg">{member.player?.name}</p>
                                    <button onClick={() => setMember(null)}><X /></button>
                                </div>
                            </div>
                            :
                            <SearchMember onSelect={(teamMember) => setMember(teamMember)} />
                    }

                    <div className="flex flex-col gap-1">
                        <p className="text-zinc-700 uppercase text-sm">Valor del contrato</p>
                        <InputText type="number" name="value" onChange={handleInputChange} placeholder="1.50"  min="0" step="0.01" value={form.value} />
                    </div>

                    <div className="flex flex-col gap-1">
                        <p className="text-zinc-700 uppercase text-sm">Fecha de inicio</p>
                        <InputText type="date" name="startDate" onChange={handleInputChange} value={form.startDate} />
                    </div>

                    <div className="flex flex-col gap-1">
                        <p className="text-zinc-700 uppercase text-sm">Fecha de finalización</p>
                        <InputText type="date" name="endDate" onChange={handleInputChange} value={form.endDate} />
                    </div>

                    <div className="flex flex-col gap-1">
                        <p className="text-zinc-700 uppercase text-sm">Condiciones</p>
                        <TextArea name="conditions" onChange={handleInputChange} value={form.conditions}></TextArea>
                    </div>

                    <Button onClick={handleSubmit} disabled={requesting} spinner={requesting}>Enviar propuesta</Button>
                </div>
            </Modal>
        </>
    )
}

export default NewContractForm